<script>
export default {
  name: "DidoMillesimeTabTable",
};
</script>

<script setup>
import DidoMillesimeTable from "../table/Index.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  rid: { type: String, required: true },
  millesime: { type: String, required: true },
  infos: { type: Object, required: true },
  initialFilter: { type: Object, required: false, default: null },
});
</script>

<template>
  <div>
    <!-- Table of Millesime Data -->
    <DidoMillesimeTable
      :api-url="props.apiUrl"
      :rid="props.infos.rid"
      :millesime="props.infos.millesime"
      :infos="props.infos"
      :initial-filter="props.initialFilter"
      class="tab-panel"
    />
  </div>
</template>
